import React, { useEffect } from "react";

import Menu from "../components/trainers/Menu.js";
import Footer from "../components/trainers/Footer.js";
import { Helmet } from "react-helmet-async";
import WebDemo from "../components/trainers/WebDemo.js";
import { useTranslation } from "react-i18next";

//import banner from "../assets/banner-restaurante.jpg"; // crea esta imagen

const TrainersDemo = () => {
	const { t } = useTranslation();

	return (
		<div style={{ backgroundColor: "#000" }}>
			<Helmet>
				<title>{t("seo.trainersDemo.title")}</title>
				<meta name="description" content={t("seo.trainersDemo.description")} />

				<link rel="canonical" href="https://applaby.com/entrenadores/demo" />
			</Helmet>
			<Menu />
			<WebDemo />
			<Footer />
		</div>
	);
};

export default TrainersDemo;
